import { SubTopicsContext } from "@shapeable/ui";
import { useContext } from "react";
import { withSubTopicAnchorPath } from "../utils/sub-topic-anchor-path";

export const useSubTopics = () => useContext(SubTopicsContext).map(withSubTopicAnchorPath);